export class ServiceAppointmentDeclinedMpviCodeQueryParameters {
  appointmentId?: string;
  campaignId?: string;
  classification?: string;
  declinedReason?: string;
  embed?: any;
  id?: string;
  opCode?: string;
  page?: number;
  pageSize?: number;
  printFlag?: string;
  sequence?: string;

  constructor(obj?: ServiceAppointmentDeclinedMpviCodeQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
